/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { Drawer, Menu, Avatar, Typography, Badge, Row, Col, Modal } from "antd";
import { push } from "connected-react-router";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import { logOut } from "reducers/session";
import { appRoutesConst } from "app/navigation";
import { clearAttrFilter } from "reducers/filter/attrFilter";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
import fileExclamation from "assets/img/file-exclamation.png"
import { Spinner } from "components/Spinner"
import { navigateToMyRewards } from "app/navigation";
import AddToHomeScreen from "components/reusable/AddToHomeScreen";
import { isIosDevice } from "utilities/utils";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
const { confirm } = Modal;
/* Const,Let & Var will be here */

class DrawerMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenAddToHomeScreenPWA: false,
            isIos: isIosDevice()
        }
    }

    navigateToHome = () => {
        const pathName = this.props.router.location.pathname;

        if (pathName !== appRoutesConst.home && this.props.appSettings.isEnableHomePage) {
            this.props.actions.push(appRoutesConst.home);
        }
        this.props.drawerMenuClose();
    }

    getTitle = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col span={6}>
                        <Avatar
                            size="large"
                            style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
                            onClick={this.navigateToHome}
                        >
                            {this.props.retailer.retailername.charAt(0)}
                        </Avatar>
                    </Col>
                    <Col span={18}>
                        <Text className="drawer-head-font text-white p-name-wrap-three-line" strong>{this.props.retailer.retailername}</Text>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    getTitleWithLink = () => {
        return (
            <React.Fragment>
                <Link
                    onClick={this.props.drawerMenuClose}
                    to={appRoutesConst.profile}
                >
                    {this.getTitle()}
                </Link>
            </React.Fragment>
        )
    }

    /* Logout button confirmation modal */
    confirmLogout = () => {
        this.props.drawerMenuClose();

        confirm({
            title: this.props.translate("common.alerts.confirmation.logoutConfirmationModalTitle"),
            centered: true,
            okText: this.props.translate("common.buttons.ok"),
            cancelText: this.props.translate("common.buttons.cancel"),
            onOk: () => {
                this.props.actions.logOut();
            }
        });
    }

    cancelAddToHomeScreen = () => {
        this.setState({ isOpenAddToHomeScreenPWA: false });
    };

    addToHomeScreen = () => {
        this.props.drawerMenuClose();
        this.setState({ isOpenAddToHomeScreenPWA: true });
    }

    navigateToMyRewards = () => {
        this.props.actions.navigateToMyRewards();
        this.props.drawerMenuClose();
    }

    /* Clear the applied attr filter from product list page before navigating to sales return or return change page */
    onReturnLink = () => {
        this.props.actions.clearAttrFilter();
        this.props.drawerMenuClose();
    }

    /* Clear the history filter when my orders and my return orders menu click */
    onHistoryLink = () => {
        this.props.actions.clearHistoryFilter();
        this.props.drawerMenuClose();
    }

    /* Menu icon */
    getMenuIcon = (item) => {
        let icon = null;
        if (item.TCode === "Complaints")
            icon = (<img className="mr-2" src={fileExclamation} alt="" />);
        else if (item.TCode === "ClubEnrollment")
            icon = (<i className={`${item.Icon} fa-lg mr-2 color-primary`} aria-hidden="true"></i>);
        else
            icon = (<i className={`${item.Icon} fa-lg mr-2`} aria-hidden="true"></i>);

        return icon;
    }

    /* Render menu list item based on menu config API response */
    getResponseMenuItem = (item) => {
        const { translate, notifications, cart, orderHistory } = this.props;

        /* Menu click event */
        let event = null;
        if (item.TCode === "SalesReturn" || item.TCode === "ExchangeReturn")
            event = this.onReturnLink;
        else if (item.TCode === "MyOrders" || item.TCode === "SalesReturnHistory" || item.TCode === "CancelOrder" || item.TCode === "MyRewards")
            event = this.onHistoryLink;
        else
            event = this.props.drawerMenuClose;

        /* Count badge */
        let countBadge = null;
        if (item.TCode === "MyOrders" && !orderHistory.list.isLoading) {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={orderHistory.list.totalCount || 0} overflowCount={999} />);
        }
        else if (item.TCode === "MyCart" && !cart.isLoading) {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={(cart.ids.length + cart.freeProducts.length) || 0} overflowCount={99} />);
        }
        else if (item.TCode === "Notifications") {
            countBadge = (<Badge className="ant-badge-green ml-1" showZero={true} count={notifications.count} overflowCount={99} />);
        }

        return (
            <Link
                onClick={event}
                to={item.Target}
                className={classNames({
                    'menu-highlight': item.TCode === "ClubEnrollment",
                })}
            >
                {translate(`common.links.${item.LCode}`)}

                {/* Check for count badge */}
                {countBadge !== null && countBadge}
            </Link>
        );
    }

    render() {
        const { translate, appSettings, logoutPersist } = this.props;
        const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);

        return (
            <React.Fragment>
                {/* Mobile menu drawer */}
                <Drawer
                    title={appSettings.isShowRetailerProfile ? this.getTitleWithLink() : this.getTitle()}
                    placement="left"
                    closable={false}
                    onClose={this.props.drawerMenuClose}
                    visible={this.props.isShowDrawerMenu}
                    className="menu-drawer"
                >
                    {/* Static menu list */}
                    <div className="menu-container">
                        <Menu
                            style={{ width: 250 }}
                            selectable={false}
                            mode="inline"
                            theme="light"
                            className={classNames('w-100', {
                                'dynamic-top-menu-with-add-to-home': ((this.state.isIos && !isInStandaloneMode) || (logoutPersist.isSupportPwa && !isInStandaloneMode)),
                                'dynamic-top-menu-without-add-to-home': !((this.state.isIos && !isInStandaloneMode) || (logoutPersist.isSupportPwa && !isInStandaloneMode))
                            })}
                        >
                            {appSettings.isLoading ?
                                <div className="menu-loading">
                                    <Spinner message={translate("common.menu.loading")} />
                                </div>
                                :
                                <React.Fragment>
                                    {/* Render menu list based on menu config API response */}
                                    {appSettings.menuList.map((item, index) => {
                                        return (
                                            <Menu.Item key={index} icon={this.getMenuIcon(item)}>
                                                {this.getResponseMenuItem(item)}
                                            </Menu.Item>
                                        );
                                    })}
                                </React.Fragment>
                            }
                        </Menu>

                        {/* dynamic bottom menu list */}
                        <Menu
                            selectable={false}
                            mode="inline"
                            theme="light"
                            className="static-bottom-menu w-100"
                        >
                            {((this.state.isIos && !isInStandaloneMode) || (logoutPersist.isSupportPwa && !isInStandaloneMode)) &&
                                <React.Fragment>
                                    <Menu.Item onClick={this.addToHomeScreen} key="addToHomeScreen" icon={<i className="fa fa-download fa-lg mr-2" aria-hidden="true"></i>}>
                                        {translate("common.buttons.addToHomeScreen")}
                                    </Menu.Item>
                                    <Menu.Divider className="menu-divider" />
                                </React.Fragment>
                            }

                            <Menu.Item onClick={this.confirmLogout} key="logout" icon={<i className="fa fa-sign-out fa-lg mr-2" aria-hidden="true"></i>}>
                                {translate("session.logout.logout")}
                            </Menu.Item>
                        </Menu>
                    </div>
                </Drawer>

                {this.state.isOpenAddToHomeScreenPWA &&
                    <AddToHomeScreen
                        isShowAddToHomeScreen={this.state.isOpenAddToHomeScreenPWA}
                        toggleAccount={this.cancelAddToHomeScreen}
                    />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    translate: getTranslate(state.locale),
    appSettings: state.appSettings,
    retailer: state.localStore.user,
    notifications: state.notifications,
    orderHistory: state.orderHistory,
    cart: state.cart,
    router: state.router,
    logoutPersist: state.logoutPersist
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            logOut,
            push,
            clearAttrFilter,
            clearHistoryFilter,
            navigateToMyRewards
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DrawerMenu);